export default __webpack_public_path__ + "static/media/P470_RoHS.462902c2.pdf";